import { useMutation, useQueryClient } from '@tanstack/react-query';
import { verlofApi } from '../../../lib/verlofApi';
import { leaveKeys } from './useMijnVerlof';

/**
 * Story 3.1 (AC-3/AC-9): de eigen uren bevestigen. Naar het model van
 * `useWithdrawLeaveRequest`: bij succes wordt het eigen overzicht ongeldig
 * verklaard, zodat de herinneringskaart de bevestigde regel kwijtraakt zodra
 * de server hem niet meer meestuurt.
 *
 * De pagina haalt de regel dus NOOIT zelf weg (AC-9). Wat het scherm toont
 * blijft staan tot het verse overzicht binnen is — anders zou een geweigerde
 * bevestiging (verstreken termijn) er stilzwijgend uitzien als een geslaagde.
 */
export function useConfirmLeaveHours() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => verlofApi.confirmHours(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: leaveKeys.mine() });
    },
  });
}
